<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="div_loading">
    <div class="my-container" [hidden]="!loading">
      <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
    </div>
  </div>
  <span>
    تمدید عضویت
  </span>
  <span (click)="close()">
    <mat-icon class="close">close</mat-icon>
  </span>
</div>

<div mat-dialog-content class="matDialogContent padding0">
  <div class="row">
    <div class="col-12 mx-auto p-4">
      <form #f2="ngForm">
        <table class="table table-bordered ">
          <tbody>
            <tr>
              <td> تاریخ انقضای اکانت</td>
              <td>
                {{ expire_date }}
              </td>
            </tr>
            <tr>
              <td>هزینه تمدید ماهیانه</td>
              <td>{{ user_amount / 10 | number }} {{ currency_title }}</td>
            </tr>
            <tr>
              <td>انتخاب مدت تمدید</td>
              <td>

                <mat-radio-group  aria-labelledby="example-radio-group-label" class="example-radio-group">
                  <mat-radio-button  (change)="changeamount($event)" class="example-radio-button" *ngFor="let plan of plans" [value]="plan">
                    {{plan}}
                  </mat-radio-button>
                </mat-radio-group>

                <input hidden="true" type="number" class="wh-input input1 center" styl max="2" name="account_month"
                  style="width:6rem !important" min="1" [max]="month_extension" [(ngModel)]="account_month" required
                  (change)="change_amount()" (keyup)="change_amount()">
              </td>
            </tr>
            <tr>
              <td>مبلغ قابل پرداخت</td>
              <td> {{ amount_final | number }} {{ currency_title }}</td>
            </tr>
            <tr>
              <td>
                <button type="button" class="btn_pe" (click)="pay()"
                  [disabled]="!f2.valid || account_month < 1 || loading2 || amount_final < 1000"
                  style="min-width: 7rem;">
                  <span *ngIf="!loading2">پرداخت آنلاین</span>
                  <span *ngIf="loading2" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                </button>
              </td>
              <td>
                پشتیبانی 0173333332
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
</div>
